import {
    AdDefinition,
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import {
    AdUnitWrapper,
    AdUnitWrapperProps,
} from '../../advertising/AdUnit/AdUnitWrapper'
import { useProduct } from '../../__product'

export const seoTestArticleIds7News = [
    'c-9320188',
    'c-7362372',
    'c-7360402',
    'c-7358116',
    'c-7357464',
    'c-7356383',
    'c-6646230',
    'c-7338647',
    'c-7252861',
    'c-5958279',
]

export type AdUnitRouteProps = Omit<AdUnitWrapperProps, 'onEvent'> & {
    slot: AdDefinition
    disableBreachAds?: boolean
}

export const AdUnitRegistration = createRegisterableComponent(
    'ad-unit',
    (
        {
            slot,
            breakout,
            hiddenUntilLoaded,
            noticePosition,
            padding,
            stickyOffset,
            unitRendered,
            preventCollapse,
            adType,
            lazyLoadingDistance,
            disableBreachAds
        }: AdUnitRouteProps,
        services,
    ) => {
        const product = useProduct()
        
        if (
            product === 'sevennews' &&
            services.resolution?.type === 'server' &&
            services.resolution?.resolution.type === 'publication'
        ) {
            const currentPublicationId =
                services.resolution.resolution.publication.id.toLowerCase()
            if (
                seoTestArticleIds7News.some(
                    (articleId) => articleId === currentPublicationId,
                )
            ) {
                return null
            }
        }
     
        return (
            <AdUnitWrapper
                adState={services.adState}
                unitId={slot.id}
                onEvent={services.onEvent}
                breakout={breakout}
                hiddenUntilLoaded={hiddenUntilLoaded}
                noticePosition={noticePosition}
                padding={padding}
                stickyOffset={stickyOffset}
                unitRendered={unitRendered}
                preventCollapse={preventCollapse}
                lazyLoadingDistance={lazyLoadingDistance}
                adType={adType}
                disableBreachAds={disableBreachAds}
            />
        )
    },
)
